import { NumberSymbol } from '@angular/common';
import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject, LinkedLocation } from 'app/shared/models/subject';
import * as L from 'leaflet';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements AfterViewInit {
  title: string = "Map";
  private map;
  subject: Subject = null;
  subjectList: LinkedLocation[] = [];

  // https://leafletjs.com/reference.html#map-option
  // https://github.com/bluehalo/ngx-leaflet/tree/e0990a3c99338fd216fef22d8e65f5e6b338334b

  constructor(
    public dialogRef: MatDialogRef<MapComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router) {
  }
  ngAfterViewInit(): void {
    this.initMap();
  }

  CloseDialog() {
    this.dialogRef.close();
  }

  private initMap(): void {

    this.map = L.map('divMap', {
      center: [53, -2],
      zoom: 10,
    });

    this.map.addLayer(L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      minZoom: 5, maxZoom: 19, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Points &copy 2012 LINZ'
    }));

    const iconRetinaUrl = 'images/marker-icon-2x.png';
    const iconUrl = 'images/marker-icon.png';
    const shadowUrl = 'images/marker-shadow.png';
    const iconDefault = L.icon({
      iconRetinaUrl,
      iconUrl,
      shadowUrl,
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      tooltipAnchor: [16, -28],
      shadowSize: [41, 41]
    });
    L.Marker.prototype.options.icon = iconDefault;

    if (this.data && this.data.subject) {
      this.subject = this.data.subject;
      var geo = L.latLng(this.subject.latitude, this.subject.longitude);
      L.marker(geo, { title: this.subject.summary }).addTo(this.map);
      this.map.setView(geo, 17);
      this.title = "Map - Showing 1 address";
    }

    if (this.data && this.data.subjectList) {

      // Handle list of subjects with Lat Long cordinates
      this.subjectList = this.data.subjectList;
      this.subjectList = this.subjectList.filter(i => i.latitude != null && i.longitude != null);

      if (this.subjectList.length > 0) {
        // Limit subjects to only show if in UK
        // Top Right = 61.441626, 2.098143
        // Bottom Left = 49.811769, -10.816523
        this.subjectList = this.subjectList.filter(i =>
          (i.latitude > 49.8 && i.latitude < 61.4)
          &&
          (i.longitude < 2.1 && i.longitude > -10.8)
        );

        this.title = "Map - Showing " + this.subjectList.length + " addresses";

        var bounds: L.LatLngBounds = new L.LatLngBounds(null);
        var markers = L.markerClusterGroup();
        this.subjectList.forEach((subject) => {
          var geo = L.latLng(subject.latitude, subject.longitude);
          var marker = L.marker(geo, { title: subject.summary });
          // marker.addTo(this.map);          
          markers.addLayer(marker);
          bounds.extend(geo);
        });

        // Marker Clustering
        this.map.addLayer(markers);

        // Zoom to fix markers
        this.map.fitBounds(bounds);
      }
    }
  }
}
